import React, { useState } from 'react';
import styles from './ui.module.css';

interface AppSplashProps {
  /** One quiet line under the mark. */
  message?: React.ReactNode;
}

/**
 * The screen the app shows while it is waking up — on a hard refresh, and while
 * AuthContext rehydrates from localStorage.
 *
 * It mirrors the pre-React splash in `index.html` so the two do not read as two
 * different loading screens: the same mark, ring and ground, so the handover
 * from static HTML to React is invisible. Change one and change the other.
 */
/** One turn of the ring, in ms — matches `splash-spin` in ui.module.css and `boot-spin` in index.html. */
const RING_PERIOD_MS = 1100;

const AppSplash: React.FC<AppSplashProps> = ({ message = 'Loading your workspace…' }) => {
  // Phase-locked to the page clock, as the HTML splash is, so the arc does not
  // snap back to the top when this replaces it.
  const [ringDelay] = useState(() => `-${performance.now() % RING_PERIOD_MS}ms`);
  return (
    <div className={styles.splash} role="status" aria-live="polite">
      <div className={styles.splashMark}>
        <span className={styles.splashRing} style={{ animationDelay: ringDelay }} aria-hidden="true" />
        <img src="/oat-mark.png" alt="OAT" width={64} height={64} />
      </div>
      <span className={styles.splashText}>{message}</span>
    </div>
  );
};

export default AppSplash;
